<template>
  <!-- Default form register -->
  <form>
    <div class="container">
      <br />
      <p class="h4 text-center mb-4">{{titel}}</p>
    </div>

    <div class="input-group input-group-sm">
      <div class="input-group-prepend">
        <span class="input-group-text">First name</span>
      </div>
      <input aria-label="First name" id="name" class="form-control" v-model="us.name" />
    </div>

    <br />

    <div class="input-group input-group-sm">
      <div class="input-group-prepend">
        <span class="input-group-text">Last name</span>
      </div>
      <input aria-label="Last name" id="lastName" class="form-control" v-model="us.last_name" />
    </div>

    <br />

    <div class="input-group input-group-sm">
      <div class="input-group-prepend">
        <span class="input-group-text">Username</span>
      </div>
      <input aria-label="username" id="username" class="form-control" v-model="us.username" />
    </div>

    <br />

    <div class="input-group input-group-sm">
      <div class="input-group-prepend">
        <span class="input-group-text">Perfil</span>
      </div>
      <!--input aria-label="perfil" id="perfil" class="form-control" v-model="us.perfil" /-->
      <!--div class="form-group"-->
      <!--label for="exampleFormControlSelect1">Example select</label-->
      <select class="form-control" id="exampleFormControlSelect1" v-model="us.perfil">
        <option value="ADMINISTRADOR">ADMINISTRADOR</option>
        <option value="USUARIO">USUARIO</option>
      </select>
      <!--/div-->
    </div>

    <br />

    <div class="input-group input-group-sm">
      <div class="input-group-prepend">
        <span class="input-group-text">Email</span>
      </div>
      <input
        type="email"
        aria-label="First name"
        id="email"
        class="form-control"
        v-model="us.email"
      />
    </div>

    <br />

    <div class="input-group input-group-sm">
      <div class="input-group-prepend">
        <span class="input-group-text">Password</span>
      </div>
      <input aria-label="Password" class="form-control" id="password" />
    </div>

    <br />

    <div class="input-group input-group-sm">
      <div class="input-group-prepend">
        <span class="input-group-text">Phone</span>
      </div>
      <input type="phone" aria-label="Phone" id="phone" class="form-control" v-model="us.tel" />
    </div>

    <br />

    <div v-show="this.update">
      <button type="button" class="btn btn-success btn-block" @click="editar(us)">Guardar</button>
      <button type="button" class="btn btn-danger btn-block" @click="eliminar(us.user_id)">Borrar</button>
      <!--button type="button" class="btn btn-success" @click="nuevo">Nuevo</button-->
    </div>

    <div class v-show="!this.update">
      <button type="button" class="btn btn-success btn-lg btn-block" @click="agregar">Agregar</button>
    </div>
    <b-button size="sm" class="float-right" variant="warning" block @click="cancel">Cancel</b-button>
  </form>
  <!-- Default form register -->
</template>

<script>
import { createNewUser, editUser, deleteUser } from "./../../api/conection";

export default {
  name: "userForm",
  props: {
    us: {
      type: Object,
      default: {}
    },
    update: false
  },
  data() {
    return {
      titel: "Formulario de Usuario"
    };
  },
  methods: {
    agregar() {
      let { name, last_name, email, tel, username, perfil } = this.us;
      const password = this.$el.querySelector("#password").value;
      const body = { name, last_name, email, password, tel, username, perfil };
      createNewUser(body)
        .then(response => {          
          if (response.status) {
            body.user_id = response.body.user.user_id;
            delete body.password;
            this.$store.dispatch("addUserAction", body);
            this.$bvModal.hide("my-user-modal");
          }
          /* limpio formulario */
          this.nuevo();
        })
        .catch(err => {
          console.log(err);
          /* limpio formulario */
          this.nuevo();
        });
    },
    editar(uss) {
      const id = uss.user_id;
      const password = this.$el.querySelector("#password").value;
      if (password !== "") {
        uss.password = password;
      }
      editUser(uss, id)
        .then(response => {         
          if (response.status === 201) {
            delete uss.password;
            this.$store.dispatch("updateUserAction", uss);
            this.$bvModal.hide("my-user-modal");
          }
          /* limpio formulario */
          this.nuevo();         
        })
        .catch(err => {
          console.log(err);
          /* limpio formulario */
          this.nuevo();
        });
    },
    eliminar(uss_id) {
      if (confirm("Está seguro que quiere borrar Este Usuario ?")) {
        deleteUser(uss_id)
          .then(result => {
            if(result.status === 200){
              this.$store.dispatch("deleteUserAction", uss_id);
              this.$bvModal.hide("my-user-modal");
            }
            /* limpio formulario */
            this.nuevo();
          })
          .catch(err => {
            console.log(err);
            /* limpio formulario */
            this.nuevo();
          });
      }
    },
    nuevo() {
      this.$el.querySelector("#password").value = "";
      this.$store.dispatch("unSelectUserAction", {});
    },
    cancel() {
      this.$store.dispatch("unSelectUserAction", {});
      this.$bvModal.hide("my-user-modal");
    }
  }
};
</script>

<style>
.input-group-text {
  min-width: 90px;
}
form {
  padding: 15px;
}
</style>